
export default {
    enablePointNumbers: function () {
        L.Editable.VertexMarker.prototype.initialize = function (latlng, latlngs, editor, options) {
            this.latlng = latlng;
            this.latlngs = latlngs;
            this.editor = editor;
            L.Marker.prototype.initialize.call(this, latlng, options);
            this.options.icon = this.editor.tools.createVertexIcon({className: this.options.className, html: `<span class="map-ediatable-icon-text">${this.getIndex() + 1}</span>`});
            this.latlng.__vertex = this;
            this.editor.editLayer.addLayer(this);
            this.setZIndexOffset(editor.tools._lastZIndex + 1);
        };
    }
}



// WEBPACK FOOTER //
// ./src/components/leaflet/pointnumbers/leaflet.pointnumbers.js